import React from "react";
import SquareButton from "../../../components/buttons/SquareButton"; // ← убедись, что buttons тоже перенесёшь в shared/ui позже
import "./Card.css";

interface CardProps {
  plant: {
    id: number;
    name: string;
    adress: string;
    photoUrl?: string;
    company_id: number;
  };
  description?: string;
  onClick: (plantId: number, companyId: number) => void;
  onEditClick: (plantId: number) => void;
}

const Card = ({
  plant,
  description = "Описание объекта",
  onClick,
  onEditClick,
}: CardProps) => {
  const handleButtonClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onEditClick(plant.id);
  };

  return (
    <div
      onClick={() => onClick(plant.id, plant.company_id)}
      className="card-container"
      style={{
        backgroundImage: plant.photoUrl
          ? `url(${process.env.REACT_APP_API_URL}${plant.photoUrl})`
          : "url(/img/photo_iset.jpg)",
        backgroundSize: "cover",
      }}
    >
      <div className="card_controls">
        <SquareButton icon="pen_green" onClick={handleButtonClick} />
      </div>
      <div className="card_content">
        <div className="card_title">{plant.name}</div>
      </div>
    </div>
  );
};

export default Card;
